import { TranslationKeys } from '@dadohr/shared/i18next.keys';
import { TypedTFunction } from 'i18next-typescript';
import {
  TFunction as _TFunction,
  useTranslation as _useTranslation
} from 'react-i18next';
import { TypedUseTranslation } from 'react-i18next-typescript';

export type TFunction = TypedTFunction<TranslationKeys>;
export type UnsafeTFunction = _TFunction;
export const useTranslation = _useTranslation as TypedUseTranslation<TranslationKeys>;
export const useUnsafeTranslation = _useTranslation;
